import {
  AppBar,
  Box,
  Button,
  Container,
  Grid,
  Toolbar,
  Typography,
  Menu,
  MenuItem
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { useUser } from "../../globals/UserContext";
import { useSetClass } from "../../globals/ClassContext";

const Navbar = ({ setPage, page }) => {
  const user = useUser();
  const setClass = useSetClass()

  //For User menu
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  //This is not the best way to do logout, should be done properly!
  //but this will work for now.
  const handleLogout = async () => {
    try {
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };
  //end of menu
  
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" color="primary">
        <Toolbar>
          <Grid container alignItems="center">
            <Grid item xs={3}></Grid>
            <Grid item container xs={10}>
              {/* <Grid item xs={2}>
                <Container display="flex" align="center" justify="center">
                  <Button
                    variant="text"
                    sx={{
                      ...(page === "home"
                        ? { color: "white" }
                        : {
                            color: "gray.main",
                            "&:hover": { color: "white", transition: "150ms" },
                          }),
                    }}
                    onClick={() => setPage("home")}
                  >
                    Home
                  </Button>
                </Container>
              </Grid> */}

              {/* <Grid item xs={2}>
                <Container display="flex" align="center" justify="center">
                  <Button
                    variant="text"
                    sx={{
                      ...(page === "adminInfo"
                        ? { color: "white" }
                        : {
                            color: "gray.main",
                            "&:hover": { color: "white", transition: "150ms" },
                          }),
                    }}
                    onClick={() => setPage("adminInfo")}
                  >
                    AdminInfo
                  </Button>
                </Container>
              </Grid> */}
              <Grid item xs={2}>
                <Container display="flex" align="center" justify="center">
                  <Button
                    variant="text"
                    sx={{
                      ...(page === "classes"
                        ? { color: "white" }
                        : {
                            color: "gray.main",
                            "&:hover": { color: "white", transition: "150ms" },
                          }),
                    }}
                    onClick={() => {setClass({}); setPage("classes")}}
                  >
                    Classes
                  </Button>
                </Container>
              </Grid>
              {/* <Grid item xs={2}>
                <Container display="flex" align="center" justify="center">
                  <Button
                    variant="text"
                    sx={{
                      ...(page === "classInfo"
                        ? { color: "white" }
                        : {
                            color: "gray.main",
                            "&:hover": { color: "white", transition: "150ms" },
                          }),
                    }}
                    onClick={() => setPage("classInfo")}
                  >
                    ClassInfo
                  </Button>
                </Container>
              </Grid> */}
              {user.isTeacher ? (
                <Grid item xs={2}>
                <Container display="flex" align="center" justify="center">
                  <Button
                    variant="text"
                    sx={{
                      ...(page === "assignments"
                        ? { color: "white" }
                        : {
                            color: "gray.main",
                            "&:hover": { color: "white", transition: "150ms" },
                          }),
                    }}
                    onClick={() => {setClass({}); setPage("assignments")}}
                  >
                    Assignments
                  </Button>
                </Container>
              </Grid>
              ) : (<div></div>)
              }
              
            </Grid>
            <Grid item xs={2}>
              <Typography variant="subtitle1" align="right" sx={{ fontSize: "12px" }} onClick={handleClick}>
                {user.email}
              </Typography>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Navbar;
